import { NgModule } from '@angular/core';
import { AbstractSecurityStorage, AuthModule } from 'angular-auth-oidc-client';
import { environment } from '@env/environment';
import { OidcStorageService } from './oidc-storage.service';
import { OidcConfigIds } from '../models/user-management.model';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        configId: OidcConfigIds.XGS,
        authority: `https://${environment.xgs.idp}`,
        redirectUrl: `${window.location.origin}/live-data`,
        postLogoutRedirectUri: `${environment.xgs.baseUrl}/sso/logout`,
        clientId: environment.xgs.clientId,
        scope: 'openid email profile roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewUserInfoAfterTokenRenew: true,
        silentRenewUrl: `https://${environment.xgs.idp}/protocol/openid-connect/token`,
        ignoreNonceAfterRefresh: true,
        autoUserInfo: true,
        logLevel: environment.xgs.logLevel,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        maxIdTokenIatOffsetAllowedInSeconds: 300,
        historyCleanupOff: false,
        triggerAuthorizationResultEvent: true
      }
    })
  ],
  providers: [
    { provide: AbstractSecurityStorage, useClass: OidcStorageService }
  ],
  exports: [AuthModule]
})
export class AuthConfigModule {}
